"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _logoName = require("../utils/propTypes/logoName");

var _UIAbstractIllustration = _interopRequireDefault(require("./UIAbstractIllustration"));

var UILogo = function UILogo(props) {
  return _react.default.createElement(_UIAbstractIllustration.default, props);
};

UILogo.defaultProps = _UIAbstractIllustration.default.defaultProps;
UILogo.propTypes = (0, _extends2.default)({}, _UIAbstractIllustration.default.propTypes, {
  name: (0, _logoName.getLogoNamePropType)().isRequired
});
UILogo.displayName = 'UILogo';
var _default = UILogo;
exports.default = _default;
module.exports = exports.default;